webpackJsonp([118],{

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ModalForm = {
    props: ['email', 'password'],
    template: '\n            <div class="modal-card" style="width: auto">\n                <header class="modal-card-head">\n                    <p class="modal-card-title">Login</p>\n                </header>\n                <section class="modal-card-body">\n                    <b-field label="Email">\n                        <b-input\n                            type="email"\n                            :value="email"\n                            placeholder="Your email"\n                            required>\n                        </b-input>\n                    </b-field>\n\n                    <b-field label="Password">\n                        <b-input\n                            type="password"\n                            :value="password"\n                            password-reveal\n                            placeholder="Your password"\n                            required>\n                        </b-input>\n                    </b-field>\n\n                    <b-checkbox>Remember me</b-checkbox>\n                </section>\n                <footer class="modal-card-foot">\n                    <button class="button" type="button" @click="$parent.close()">Close</button>\n                    <button class="button is-primary">Login</button>\n                </footer>\n            </div>\n        '
};

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ModalForm: ModalForm
    },
    data: function data() {
        return {
            isComponentModalActive: false,
            formProps: {
                email: 'evan@you.com',
                password: 'testing'
            }
        };
    }
});

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = true
      }
    }
  }, [_vm._v("\n            Launch component modal\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": "",
      "full-screen": "",
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('modal-form', _vm._b({}, 'modal-form', _vm.formProps, false))], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1126),
  /* template */
  __webpack_require__(1127),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/118.f96f752188635ea83cea.js